import React, { useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { useTranslation } from 'react-i18next'

interface IMenuProps {
    buttonElemnts: any
}

const Menu: React.FC<IMenuProps> = ({ buttonElemnts }) => {
    const [showMenu, setShowMenu] = useState(false)
    const { t } = useTranslation()
    const handleShowMenu = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        setShowMenu(true);
    }
    const handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => setShowMenu(false)

    return (
        <div className={'menu-toggle'}>
            <button onClick={handleShowMenu}>
                {buttonElemnts}
            </button>

            {showMenu ?
                <div className="menu-body">
                    <div className="menu-header clearfix">
                        <div className="logo">
                            <img src="/images/logo/logo.jpg" alt="360 Tourist" />
                        </div>
                        <div className="close_icon">
                            <button onClick={handleCloseMenu}>
                                {t('CLOSE')}
                                <img src="/images/icons/close-icon.png" alt="close" />
                            </button>
                        </div>
                    </div>
                    <Scrollbars className="scroll-wrapper" >
                        <div className="body-wrapper clearfix">
                            <div className="columns medium-6 p-l0">
                                <ul className="nav-list">
                                    <li>
                                        <a href="/">{t('Destinations')}</a>
                                    </li>
                                    <li>
                                        <a href="/">{t('Real Estate')}</a>
                                    </li>
                                    <li>
                                        <a href="/">{t('About')}</a>
                                    </li>
                                    <li>
                                        <a href="/">{t('Booking')}</a>
                                    </li>
                                    <li>
                                        <a href="/">{t('Dream Villas on Rent')}</a>
                                    </li>
                                    <li>
                                        <a href="/">{t('Contact')}</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="columns medium-6">
                                <ul className="medium-block-grid-3">
                                    <li>
                                        <img src="/images/promote.jpg" alt="promote" />
                                    </li>
                                    <li>
                                        <img src="/images/panaromic.jpg" alt="panaromic" />
                                    </li>
                                    <li>
                                        <img src="/images/connect-provider.jpg" alt="connect-provider" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Scrollbars>
                </div> : null
            }
        </div>
    )
}

export default Menu;